module.exports = __webpack_public_path__ + "static/delivery-fa4bd987312400c93df35958eb1c3b6f.png";